import { render, staticRenderFns } from "./BaseShortInfo.vue?vue&type=template&id=3fe9fd1c&scoped=true&"
import script from "./BaseShortInfo.vue?vue&type=script&lang=js&"
export * from "./BaseShortInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseShortInfo.vue?vue&type=style&index=0&id=3fe9fd1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe9fd1c",
  null
  
)

export default component.exports